/**
 * "DIE REISE" — Signature 3, fallback path only.
 * candy-journey.css already drives the reveal natively via
 * `animation-timeline: view()` wherever that's supported (Chrome/Edge/
 * Safari 18+) — this script is a no-op there (@supports guards it out).
 * On everything else, and whenever prefers-reduced-motion is on, this
 * adds `.is-visible` per stage via IntersectionObserver, which the same
 * CSS file picks up with a plain (non-scroll-linked) transition. Either
 * path animates the same two properties, so there's never a visual gap
 * between what a modern and an older browser show.
 */
(function () {
  function supportsNativeTimeline() {
    return typeof CSS !== 'undefined' && CSS.supports && CSS.supports('animation-timeline: view()');
  }

  function init() {
    if (supportsNativeTimeline() && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return;
    }

    var stages = document.querySelectorAll('.candy-journey-stage');
    if (!stages.length || typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.35 }
    );

    stages.forEach(function (stage) {
      observer.observe(stage);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
